export const SHIPPINGS_REQUEST = 'SHIPPINGS_REQUEST';
export const SHIPPINGS_REQUEST_SUCCESS = 'SHIPPINGS_REQUEST_SUCCESS';
export const SHIPPINGS_REQUEST_FAILED = 'SHIPPINGS_REQUEST_FAILED';
